export default __webpack_public_path__ + "static/media/enghien20.d0f6ebc8.jpg";